// extracted by mini-css-extract-plugin
module.exports = {"container":"localLogic_container__3hhg4"};
    if(module.hot) {
      // 1790670314144
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  